<template>
  <div class="index">
    <div class="index_box">
      <LeftSideBar></LeftSideBar>
      <CategoryList></CategoryList>
      <!-- banner -->
      <el-carousel arrow="never" class="banner" height="443px">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div class="demo111" data-key="5S" :data-id="item.id">
            <img :src="item.url" :alt="item.categoryName" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <!-- 列表 -->
      <div
        class="list_box flex-sp"
        :id="'list' + index"
        v-for="(item, index) in categoryList"
        :key="index"
      >
        <div class="list_left">
          <div class="list_left_title ell_one">{{ item.categoryName }}</div>
          <div class="list_left_img">
            <img :src="item.imgUrl" alt="" srcset="" />
          </div>
        </div>
        <div class="list_right">
          <ul class="title_list_box flex-st">
            <el-tabs v-model="activeIndexList[index]" @tab-click="handleClick">
              <el-tab-pane
                :data-parentIndex="index"
                :data-index="indexChild"
                :label="itemChild.categoryName"
                :name="indexChild.toString()"
                v-for="(itemChild, indexChild) in item.children"
                :key="indexChild"
              ></el-tab-pane>
            </el-tabs>
          </ul>
          <div class="goods_list">
            <div class="goods_list_box flex-st">
              <dl
                v-for="(itemChild, indexChild) in goodsList[index]"
                :key="indexChild"
                @click="openGoodsDetail(itemChild)"
              >
                <img
                  class="goods_img"
                  :src="itemChild.skuPicUrl"
                  v-show="itemChild.skuPicUrl"
                  :alt="itemChild.title"
                />
                <img
                  src="~@/assets/img/bitmap.png"
                  class="goods_img"
                  v-show="!itemChild.skuPicUrl"
                  :alt="itemChild.title"
                />
                <dd class="ell_one">{{ itemChild.title }}</dd>
                <dt>
                  <span class="old_price">￥{{ itemChild.tagPrice ? itemChild.tagPrice : itemChild.sellingPrice  }}</span>
                  <span class="price">￥{{ itemChild.channelPrice }}</span>
                </dt>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftSideBar from '@/views/modules/punchout/components/leftSideBar'
import CategoryList from '@/views/modules/punchout/components/categoryList'

export default {
  name: 'punchoutIndex',
  components: {
    LeftSideBar,
    CategoryList
  },
  data () {
    return {
      bannerList: [
        {
          url:
            'https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/punchout/punchoutBanner-01.png'
        },
        {
          url:
            'https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/punchout/punchoutBanner-02.png'
        }
      ], // banner列表
      activeIndexList: [], //
      goodsList: [] // 商品列表 二维
    }
  },
  computed: {
    categoryList () {
      let list = []
      list = list
        .concat(this.$store.state.punchout.punchoutCategoryList)
        .slice(0, 7)
      list.forEach((item, index) => {
        list[
          index
        ].imgUrl = `https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/punchout/punchoutCate-0${index +
          1}.png`
      })
      return list
    }
  },
  created () {
    if (!this.bus._events['categoryList-event']) {
      this.bus.$on('categoryList-event', val => {
        this.init()
      })
    }
  },
  mounted () {},
  methods: {
    init () {
      // 获取所有二级分类ID
      let categoryListIds = []
      this.categoryList.forEach((item, index) => {
        categoryListIds.push({
          categoryId: item.children[0].categoryId,
          sort: index + 1
        })
      })
      this.getGoodsList(categoryListIds)
    },
    // 获取图片列表
    getGoodsList (categoryListIds, index) {
      this.$http
        .post(`/front/punchout/commodity/commodityListBySecondLevel`, {
          categoryIds: categoryListIds
        })
        .then(res => {
          if (index !== undefined) {
            this.goodsList[index] = res.data.data[0]
          } else {
            this.goodsList = res.data.data
          }
          this.$forceUpdate()
        })
    },
    // 二级分类切换
    handleClick (tab, event) {
      let parentIndex = tab.$attrs['data-parentIndex']
      let index = tab.$attrs['data-index']
      let categoryListIds = [
        {
          categoryId: this.categoryList[parentIndex].children[index]
            .categoryId,
          sort: 1
        }
      ]
      this.getGoodsList(categoryListIds, parentIndex)
    },
    // 二级类目选中
    selectCateTwo (index, indexChild) {
      if (this.activeIndexList[index] !== indexChild) {
        this.activeIndexList[index] = indexChild
        this.$forceUpdate()
      }
    },
    // 打开商品详情
    openGoodsDetail (val) {
      this.$router.push({
        name: 'punchoutGoodsDetail',
        query: {
          spuId: val.spuId,
          skuId: val.skuId
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.index {
  position: relative;
  .index_box {
    width: 1190px;
    margin: 0 auto;
    padding-bottom: 30px;
  }
  .banner {
    background: #ffffff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.07);
    width: 937px; // 937
    height: 443px; // 443px
    margin: 10px 0 0 245px;
    img {
      width: 100%;
      height: 100%;
    }
    .small {
      width: 937px;
      height: 443px;
      background-position: center;
      background-size: 100%;
    }
    /deep/ .el-carousel .el-carousel__container {
      height: 352px !important;
    }
  }
  .list_box {
    margin-top: 36px;
    .list_left {
      width: 235px;
      height: 490px;
      .list_left_title {
        font-size: 26px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #262626;
        line-height: 37px;
        height: 57px;
      }
      .list_left_img {
        width: 100%;
        height: 430px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .list_right {
      width: 943px;
      height: 430px; // 615px
      /deep/ .el-tabs__nav-wrap::after {
        background: rgba(0, 0, 0, 0);
      }
      /deep/ .el-tabs__item.is-active {
        background-color: #1d65a8;
        color: #ffffff;
      }
      /deep/ .el-tabs__active-bar {
        height: 0;
      }
      /deep/ .el-tabs__item {
        padding: 0 7px;
        line-height: 36px;
        height: 36px;
      }
      .title_list_box {
        width: 100%;
        overflow: auto;
        flex-wrap: nowrap;
        height: 57px;
        li {
          height: 26px;
          line-height: 26px;
          padding: 0 7px;
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #262626;
          margin: 8px 20px 0 0;
          cursor: pointer;
        }
        .li_active {
          background: #2c5ea2;
          color: #ffffff;
        }
      }
      .goods_list {
        background: #ffffff;
        width: 937px;
        height: 430px;
        padding: 0 20px;
        .goods_list_box {
          width: 937px;
          dl {
            cursor: pointer;
            margin-right: 21px;
            margin-bottom: 16px;
            width: 163px;
            .goods_img {
              width: 142px;
              height: 137px;
              margin: 0 auto;
              display: block;
            }
            dd {
              margin: 0;
              font-size: 14px;
              font-weight: 400;
              text-align: center;
              color: #333333;
              line-height: 30px;
            }
            dt {
              font-size: 14px;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
              text-align: center;
              margin: 0;
              .old_price {
                text-decoration: line-through;
                margin-right: 10px;
              }
              .price {
              }
            }
          }
        }
        // padding-left: ;
        overflow: hidden;
      }
    }
  }
}
</style>
